import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useTranslation } from '@/contexts/LanguageContext';
import { useState, useEffect } from 'react';

interface CurrencyInputProps {
  value: number;
  currency: 'BRL' | 'USD';
  onValueChange: (value: number) => void;
  onCurrencyChange: (currency: 'BRL' | 'USD') => void;
  showLabel?: boolean;
}

export function CurrencyInput({
  value,
  currency,
  onValueChange,
  onCurrencyChange,
  showLabel = true,
}: CurrencyInputProps) {
  const { t } = useTranslation();
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    setDisplayValue(value.toString());
  }, [value]);

  const formatCurrency = (val: number, curr: 'BRL' | 'USD') => {
    return new Intl.NumberFormat(curr === 'BRL' ? 'pt-BR' : 'en-US', {
      style: 'currency',
      currency: curr,
      minimumFractionDigits: 2,
    }).format(val);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.replace(/[^\d]/g, '');
    const numericValue = parseInt(inputValue || '0') / 100;
    onValueChange(numericValue);
    setDisplayValue(inputValue);
  };

  const handleBlur = () => {
    setDisplayValue(value.toString());
  };

  return (
    <div className={showLabel ? "space-y-2" : ""}>
      {showLabel && <Label>{t('targetValue')}</Label>}
      <div className="flex gap-2">
        <Select value={currency} onValueChange={(val) => onCurrencyChange(val as 'BRL' | 'USD')}>
          <SelectTrigger className="w-24">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="BRL">R$</SelectItem>
            <SelectItem value="USD">$</SelectItem>
          </SelectContent>
        </Select>
        <Input
          type="text"
          value={formatCurrency(value, currency)}
          onChange={handleInputChange}
          onBlur={handleBlur}
          placeholder={formatCurrency(0, currency)}
        />
      </div>
    </div>
  );
}
